import { PenIcon, TrashIcon } from "@xola/icons";
import { Badge } from "@xola/ui-kit";
import clsx from "clsx";
import { FormField, InputField } from "common";
import React from "react";
import { TelemetryModule, TelemetryModuleParameter, TelemetryParameterType } from "types";
import { SecondaryButton } from "../Common/SecondaryButton";
import { PromptModal } from "@/components/Common/PromptModal";
import { useVisibility } from "@/hooks/useVisibility";

interface TelemetryParameterItemProps {
    module: TelemetryModule;
    parameter: TelemetryModuleParameter;
    index: number;
    onEdit: (parameter: TelemetryModuleParameter) => void;
    onDelete: (parameter: TelemetryModuleParameter) => void;
}

export const TelemetryParameterItem = ({ parameter, module, onEdit, onDelete, index }: TelemetryParameterItemProps) => {
    const [showDeleteModal, { toggle: toggleShowDeleteModal }] = useVisibility(false);
    const handleParameterEdit = () => {
        onEdit(parameter);
    };

    const handleParameterDeleteConfirm = () => {
        onDelete(parameter);
    };

    return module.seller ? (
        <div
            className={clsx(
                "ui-guide-item flex cursor-pointer items-center overflow-hidden border-b border-b-gray-light px-5 py-4.5 hover:bg-gray-lighter xl:px-10",
            )}
        >
            <div className="w-2/6 flex-shrink-0">
                <h3 className="truncate text-lg font-bold leading-p2 tracking-tightest">{parameter.label}</h3>
                <div className="mt-2 flex flex-auto space-x-4">
                    {parameter.type ? <Badge color="secondary">{parameter.type}</Badge> : null}
                    {parameter.key ? <Badge color="secondary">{parameter.key}</Badge> : null}
                </div>
            </div>
            <div className="flex flex-auto justify-end space-x-2">
                <SecondaryButton
                    data-testid="telemetry-parameter-item-edit-button"
                    size="small"
                    onClick={handleParameterEdit}
                >
                    <PenIcon />
                </SecondaryButton>

                <SecondaryButton
                    data-testid="telemetry-parameter-item-delete-button"
                    size="small"
                    onClick={toggleShowDeleteModal}
                >
                    <TrashIcon />
                </SecondaryButton>
            </div>
            <PromptModal
                title="Delete Parameter?"
                isOpen={showDeleteModal}
                onConfirm={handleParameterDeleteConfirm}
                onClose={toggleShowDeleteModal}
            >
                Are you sure you want to delete this parameter?
            </PromptModal>
        </div>
    ) : parameter.type === TelemetryParameterType.SECRET || parameter.type === TelemetryParameterType.STRING ? (
        <FormField label={parameter.label} name={`parameters.${index}.value`}>
            <InputField
                name={`parameters.${parameter.key}`}
                placeholder={parameter.caption}
                type={parameter.type === TelemetryParameterType.SECRET ? "password" : "text"}
            />
        </FormField>
    ) : null;
};
